// extracted by mini-css-extract-plugin
module.exports = {"f-AtomImage":"Image_f-AtomImage__0OCkf","f-AtomImage-position--centered":"Image_f-AtomImage-position--centered__feCmU"};